import type { Series } from '../types';

import { isMediaId, MediaId } from '../../media';

export function getSeriesTrailerMediaId(series: Series): MediaId | null {
  const mediaId = series?.trailer?.brightcove_id;

  if (isMediaId(mediaId)) {
    return mediaId;
  }
  return null;
}
